import { Button, message } from "antd";
import { useState } from "react";
import { serverFetch } from "../../server";

const Event = ({ item, onRefresh }) => {
  const [loading, setLoading] = useState(false);

  const onRead = () => {
    setLoading(true);
    serverFetch(`event/SetRead/${item.id}`, { method: "PUT" })
      .then(onRefresh)
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  };

  return<div className="event">
    <div><strong>{item.subject}</strong></div>
    <div>{item.text}</div>
    <Button disabled={loading} onClick={onRead}>Прочитать</Button>
  </div>
}

export default Event;